<template>
  <div class="box_content">
    <!-- <template v-if="IsLoaded && InterruptData && IsTimeOut"> -->
    <template v-if="IsLoaded ">
      <div v-if='!noRoot'>
        <div class="con_config">
          <Popup
            v-model="popup_show"
            position="top"
            overlay-class="popup_box"
            :close-on-click-overlay="true"
            :lock-scroll="true"
            :lazy-render="false"
          >
            <img class="WXTExtension_popup" :src="popup_img" />
          </Popup>
        </div>
        <img
          :src="$OSS + 'reactangle.png'"
          class="bg_nav"
          alt=""
        />
        <div class="box_header">
          <div class="shop_data">
            <div class="nick_name">{{ pageData.visitor_nick }}</div>
            <div class="last_date">
              剩余服务时间<span
                class="days"
                :class="pageData.surplus_days <= 30 ? 'yellowarrow' : ''"
              >
                {{ pageData.surplus_days }} </span
              >天
              <div
                class="renew"
                v-if="GetYesterdayShops.length > 1"
                @click="RenewBtn({ btn_name: 'renew_now' })"
              >
                立即续费>
              </div>
            </div>
          </div>
          <div class="switch">
            <button
              v-if="GetYesterdayShops.length > 1"
              class="btn switch_btn"
              @click="pickerClick()"
            >
              切换店铺
            </button>
            <button
              v-else
              class="btn xf_btn"
              @click="RenewBtn({ btn_name: 'renew_now' })"
            >
              立即续费
            </button>
          </div>
        </div>
        <div v-if="pageData.no_send_num>0" class="icon_box" :class="pageData.no_send_num?'icon_show':'' ">
          <NoticeBar
            class="banner"
            :scrollable="true"
            color="#FF5700"
            background="#FFECE2"
            :text="`您有 ${pageData.no_send_num||0} 笔订单买家已付款，仍未发货，请尽快处理！`"
          />
          <img :src="$OSS + 'MerchantsDay_laba.png'" alt="" />
        </div>
        <div class="box_main">
          <div class="box_li">
            <div class="main_title">
              <img :src="$OSS + 'dp.png'" alt="" />
              <span>店铺数据</span>
            </div>
            <ul class="mian_content">
              <li>
                <div class="cotent_li">店铺销售金额(元)</div>
                <div class="content_num">{{ pageData.shop_true_pay }}</div>
              </li>
              <li>
                <div class="cotent_li">成交订单(笔)</div>
                <div class="content_num">{{ pageData.true_order_num }}</div>
              </li>
              <li>
                <div class="cotent_li">成交人数(人)</div>
                <div class="content_num">{{ pageData.true_people_num }}</div>
              </li>
            </ul>
          </div>
          <div class="box_li">
            <div class="main_title">
              <img :src="$OSS + 'message.png'" alt="" />
              <span>消息分析</span>
            </div>
            <ul class="mian_content">
              <li>
                <div class="cotent_li">已发送消息(条)</div>
                <div class="content_num">{{ pageData.has_send_num }}</div>
              </li>
              <li>
                <div class="cotent_li">已处理消息(条)</div>
                <div class="content_num">{{ pageData.has_process_num }}</div>
              </li>
              <li>
                <div class="cotent_li">消息处理率(%)</div>
                <div class="content_num">{{ pageData.process_rate }}</div>
              </li>
            </ul>
          </div>
          <div class="box_li">
            <div class="main_title main_titlelink">
              <div class="title">
                <img :src="$OSS + 'ren.png'" alt="" />
                <span>客户类型</span>
              </div>
              <div class="title_link" @click="clickDetail()">
                查看详情
                <Icon name="arrow" class="van-icon_arrow" />
              </div>
            </div>
            <ul class="mian_content">
              <li>
                <div class="cotent_li">新客户(人)</div>
                <div class="content_num">{{ pageData.new_num }}</div>
              </li>
              <li>
                <div class="cotent_li">老客户(人)</div>
                <div class="content_num">{{ pageData.old_num }}</div>
              </li>
              <li>
                <div class="cotent_li">忠诚客户(人)</div>
                <div class="content_num">{{ pageData.loyal_num }}</div>
              </li>
            </ul>
          </div>
        </div>
        <div class="box_mainsecond">
          <img
            :src="$OSS + 'rectangle_2.png'"
            alt=""
            class="h_arrow"
          />
          <div class="second_title">本月累计数据</div>
          <f2TemView v-if="chats_show" :setData="mouth_totalData" />
        </div>
        <Popup v-model="shopPicker" position="bottom">
          <Picker
            show-toolbar
            value-key="visitor_nick"
            title="选择店铺"
            confirm-button-text="确定"
            :columns="GetYesterdayShops"
            :visible-item-count="5"
            @confirm="setStudentClass"
            @cancel="shopPicker = false"
            :default-index='visitor_index'
          ></Picker>
        </Popup>
        <div class="special_popup_box">
          <!-- 服务到期 续费提醒 弹窗 -->
          <Popup v-model="IsTimeOut" position="center">
              <div class="popup_IsTimeOut">
                  <img @click="popup_IsTimeOut_close" class="popup_IsTimeOut_close" :src="$OSS+'close.png'" alt="关闭">
                  <img class="popup_IsTimeOut_img" :src="$OSS+'YesterdayBriefingTimeOut.png'" alt="到期图标">
                  <div class="popup_IsTimeOut_title">旺信通服务已过期</div>
                  <div class="popup_IsTimeOut_text">无法查看数据，以免数据丢失</div>
                  <div class="popup_IsTimeOut_text">请尽快续费！</div>
                  <div @click="popup_IsTimeOut_button" class="popup_IsTimeOut_button">立即续费</div>
              </div>
          </Popup>
          <!-- 服务到期 续费提醒 弹窗 -->
          <Popup v-model="InterruptData" position="center">
              <div class="popup_InterruptData">
                  <img @click="popup_InterruptData_close" class="popup_InterruptData_close" :src="$OSS+'close.png'" alt="关闭">
                  <img class="popup_InterruptData_img" :src="$OSS+'YesterdayBriefingSyncData.png'" alt="到期图标">
                  <div class="popup_InterruptData_title">数据同步中</div>
                  <div class="popup_InterruptData_text">由于服务到期导致数据中断</div>
                  <div class="popup_InterruptData_text">系统正在同步数据，请稍后查看</div>
              </div>
          </Popup>
        </div>
      </div>
      <div v-if='noRoot' class="noRootClass">
        <img :src="$OSS+'rootLost.png'" alt="">
        <p>您当前没有权限查看</p>
        <p>请联系老板在设置页开通</p>
      </div>
    </template>
    <!-- 加载时的loading -->
    <template v-if="!IsLoaded">
      <SelfLoading />
    </template>
  </div>
</template>
<script>
import { Toast, NoticeBar, Icon, Picker, Popup } from "vant";
import { mapState } from "vuex";
import f2TemView from "./compontent/f2";
import SelfLoading from "@/components/SelfLoading";
import { URL10,URL11 } from "@/utils/Redirect";
export default {
  name: "YesterdayBriefing",
  data() {
    let popup_img;
    if (this.$config.SystemOS == "IOS") {
      popup_img = this.$OSS + "renew_tips_ios.png";
    } else {
      popup_img = this.$OSS + "renew_tips_android.png";
    }
    let mouth_totalData = [
      [
        { name: "新客户询盘", persent: 0, a: "1", proportion: 0, sum: 0,},
        { name: "老客户询盘", persent: 0, a: "1", proportion: 0, sum: 0,},
      ],
      [
        { name: "新客户销售额", persent: 0, a: "2", proportion: 0, sum: 0,},
        { name: "老客户销售额", persent: 0, a: "2", proportion: 0, sum: 0,},
      ],
    ];
    return {
      IsLoaded: false,
      InterruptData: false,
      IsTimeOut: false,
      chats_show: true,
      popup_img,
      mouth_totalData,
      popup_show: false,
      pageData: {}, //数据
      shopPicker: false, //picker
      visitor_id: this.$route.query.briefing_id,
      GetYesterdayShops: [],
      briefing_serv_jump: '',
      visitor_index: 0,
      overdueType: 0,
      noRoot: false,
    };
  },
  components: {
    Toast,
    NoticeBar,
    Icon,
    f2TemView,
    Picker,
    Popup,
    SelfLoading,
  },
  computed: {
    ...mapState({
      // GetYesterdayShops: (state) => {
      //   return state.YesterdayBriefing.GetYesterdayShops;
      // },
      UserInfo: (state) => {
          return state.Public.UserInfo;
      },
    }),
  },
  mounted() {
    this.pageCollect({ briefing_id: this.$route.query.briefing_id });
    let visitor_id = sessionStorage.getItem("visitor_id")
    if( visitor_id ){
      this.getData( {visitor_id});
    }else{
      this.getData();
    }
    this.getShopLength();
  },
  methods: {
    // 埋点
    pageCollect(parame) {
      let data = {
        page_from: "main_page",
        page_name: "YesterdayBriefing",
        page_time: "0.00",
        receiver_id: "",
        page_param: parame || {},
      };
      this.$store.dispatch("Public/inH5Record", data);
    },
    // 显示弹窗
    RenewBtn(parame) {
      let data = {
        page_from: "main_page",
        page_name: "YesterdayBriefing",
        page_time: "0.00",
        receiver_id: "",
        page_param: parame || {},
      };
      this.$store.dispatch("Public/inH5Record", data).then((res)=> {
        
        if(this.briefing_serv_jump == 1) {
          window.location.href= URL10
        }else {
          window.location.href= URL11
        }
      });
      
    },
    // 获取数据
    getData(data = { briefing_id: this.$route.query.briefing_id }) {
      this.$store
        .dispatch("YesterdayBriefing_APP/GetYesterdayBriefing", data)
        .then((res) => {
          let data = res.data;
          this.IsLoaded = true; //加载完成标识
          if (res.code == "4031") {
            this.IsTimeOut = true;
            this.overdueType = 1
            this.briefing_serv_jump = data.briefing_serv_jump
          }
          if (res.code == "4032") {
            this.InterruptData = true;
            this.briefing_serv_jump = data.briefing_serv_jump
          }
          if(res.code == "4019"){
            Toast("消息不存在")
          }
          if(res.code == "4029"){
            // Toast("非店铺老板无权查看")
            this.noRoot = true
          }
          if(res.code == "4030"){
            Toast("新绑定用户还未更新昨日数据，明日可点击查看")
            this.briefing_serv_jump = data.briefing_serv_jump
          }
          if(res.code == "4037"){
            Toast("等待数据更新中")
            this.overdueType = 1
            this.briefing_serv_jump = data.briefing_serv_jump
          }
          if(res.code == '1000'){
            this.InterruptData = false;
            this.IsTimeOut = false;
            this.overdueType = 0
            this.briefing_serv_jump = data.briefing_serv_jump
          }
          if (Object.keys(data).length) {
            this.pageData = data;
            for(let i in this.GetYesterdayShops) {
              if(this.GetYesterdayShops[i].visitor_nick == this.pageData.visitor_nick) {
                this.visitor_index = i
              }
            }
            this.visitor_id = data.visitor_id;
            this.mouth_totalData = [
              [
                {
                  persent: parseFloat(data.xunpan_new_num),
                  name: "新客户询盘",
                  a: "1",
                  proportion: parseFloat(data.xunpan_new_persent),
                  sum: data.xunpan_total_num,
                },
                {
                  persent: parseFloat(data.xunpan_old_num),
                  name: "老客户询盘",
                  a: "1",
                  proportion: parseFloat(data.xunpan_old_persent),
                  sum: data.xunpan_total_num,
                },
              ],
              [
                {
                  persent: parseFloat(data.new_sale_payment),
                  name: "新客户销售额",
                  a: "2",
                  proportion: parseFloat(data.new_sale_persent),
                  sum: data.total_sale_payment,
                },
                {
                  persent: parseFloat(data.old_sale_payment),
                  name: "老客户销售额",
                  a: "2",
                  proportion: parseFloat(data.old_sale_persent),
                  sum: data.total_sale_payment,
                },
              ],
            ];
          }
          this.chats_show = false;
          this.$nextTick(() => {
            this.chats_show = true;
          });
          
        });
    },
    //获取多店铺
    getShopLength() {
      this.$store.dispatch("YesterdayBriefing_APP/GetYesterdayShops").then((res)=> {
        this.GetYesterdayShops = res.data
      });
    },
    pickerClick() {
      this.shopPicker = true;
    },
    // picker确认
    setStudentClass(value, index) {
      this.shopPicker = false;
      this.visitor_id = value.visitor_id;
      sessionStorage.setItem("visitor_id", value.visitor_id);
      this.getData({ visitor_id: value.visitor_id });
    },
    // 跳转客户详情
    clickDetail() {
      if (this.visitor_id) {
        this.$router.push({
          path: "YesterdayDetail",
          query: { visitor_id: this.visitor_id, overdueType: this.overdueType },
        });
      }
    },
    
    // 续费
    renew() {
      if(this.briefing_serv_jump == 1) {
        window.location.href= URL10
      }else {
        window.location.href= URL11
      }
    },
    // 关闭过期提示弹窗
    popup_IsTimeOut_close(){
        this.IsTimeOut = false
    },
    popup_IsTimeOut_button(){
        if(this.briefing_serv_jump == 1) {
          window.location.href= URL10
        }else {
          window.location.href= URL11
        }
    },
    // 关闭过期提示弹窗
    popup_InterruptData_close(){
        this.InterruptData = false
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>